export function buildName(...nameParts: (string | null)[]) {
    return nameParts.filter((part) => part !== null).join(' ');
}
